<div class="tile-progress bg-white text-left col-lg-12">
  <div class="col-lg-6" style="padding-left: 0;">
    <label>Select account to configure field</label>
    <ng-select style="width:70%" [items]="accounts"
      (change)="selectedTab='DIAGNOSIS';copyFromAccountId=0;getConfigurations(accountId,'DIAGNOSIS',false)"
      name="accounts" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId"
      [(ngModel)]="accountId" placeholder="Select Account">
    </ng-select>
  </div>
  <!--<div class="col-lg-6" *ngIf="accounts!=null && accountId>0">
      <label>Select device type</label>
      <ng-select [items]="devices" (change)="getConfigurations()"
          name="devices.name" bindLabel="name" [clearable]="true" [searchable]="true" bindValue="value" [(ngModel)]="deviceId"
          placeholder="Select Module for this account">
      </ng-select>
  </div>-->
</div>
<ul *ngIf="accounts!=null && accountId!=null && accountId>0" class="nav nav-tabs"
  style="margin-left:27px; display: block;">
  <li [ngClass]="{active:selectedTab=='DIAGNOSIS'}"
    (click)="selectedTab='DIAGNOSIS';copyFromAccountId=0;getConfigurations(accountId,'DIAGNOSIS',false)"><a
      style="border-radius: 0px;padding: 10px;font-size: 14px;">Diagnosis(ICD Codes)</a></li>
  <li [ngClass]="{active:selectedTab=='FINDINGS'}"
    (click)="selectedTab='FINDINGS';copyFromAccountId=0;getConfigurations(accountId,'FINDINGS',false)"><a
      style="border-radius: 0px;padding: 10px;font-size: 14px;">Findings</a></li>
  <li [ngClass]="{active:selectedTab=='PROGRESSION'}"
    (click)="selectedTab='PROGRESSION';copyFromAccountId=0;getConfigurations(accountId,'PROGRESSION',false)"><a
      style="border-radius: 0px;padding: 10px;font-size: 14px;">Progression</a></li>
  <li [ngClass]="{active:selectedTab=='RECOMMENDATIONS'}"
    (click)="selectedTab='RECOMMENDATIONS';copyFromAccountId=0;getConfigurations(accountId,'RECOMMENDATIONS',false)"><a
      style="border-radius: 0px;padding: 10px;font-size: 14px;">Recommendation</a></li>
  <li [ngClass]="{active:selectedTab=='OPERATOR_REMARKS'}"
    (click)="selectedTab='OPERATOR_REMARKS';copyFromAccountId=0;getConfigurations(accountId,'OPERATOR_REMARKS',false)">
    <a style="border-radius: 0px;padding: 10px;font-size: 14px;">Operator Remarks</a>
  </li>
  <li [ngClass]="{active:selectedTab=='MRN_CONFIGURATION'}"
    (click)="selectedTab='MRN_CONFIGURATION';copyFromAccountId=0;getConfigurations(accountId,'MRN_CONFIGURATION',false)">
    <a style="border-radius: 0px;padding: 10px;font-size: 14px;">MRN Configuration</a>
  </li>
  <li [ngClass]="{active:selectedTab=='ACCOUNT_CONFIGURATION'}"
    (click)="selectedTab='ACCOUNT_CONFIGURATION';copyFromAccountId=0;getConfigurations(accountId,'ACCOUNT_CONFIGURATION',false)">
    <a style="border-radius: 0px;padding: 10px;font-size: 14px;">Account Configuration</a>
  </li>
</ul>
<div
  *ngIf="accounts!=null && accountId!=null && accountId>0 && (selectedTab!='MRN_CONFIGURATION' && selectedTab!='ACCOUNT_CONFIGURATION')"
  style="padding-left:27px">
  <label style="margin-top:10px">Copy Fields From Account</label>
  <ng-select style="width:35%;" [items]="accounts" (change)="getConfigurations(copyFromAccountId,selectedTab,true)"
    name="accounts" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId"
    [(ngModel)]="copyFromAccountId" placeholder="Select Account">
  </ng-select>
</div>
<!-- start : ICD Codes-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='DIAGNOSIS'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Diagnosis(ICD Code) Configuration
    <div class="pull-right">
      <!-- <button class="btn btn-sm btn-primary" style="margin-top: -4px;" (click)="copyFromAccountId=0;addNewRow('DIAGNOSIS')">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field
    </button>
    <button class="btn btn-sm btn-warning" style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;" (click)="copyFromAccountId=0;getDefaultConfigurations('DIAGNOSIS')">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add Default Fields
    </button>
    <button class="btn btn-sm btn-danger" style="margin-top: -4px;margin-left: 5px;" (click)="copyFromAccountId=0;deleteConfigurations('DIAGNOSIS')">
      <i class="fa fa-trash" style="margin-top:6px;color:#fff;"></i> Remove All Fields
    </button> -->
      <button *ngIf="isEnebleAllIcdCodes && configurationList.length>0" class="btn btn-sm btn-primary"
        style="margin-top: -4px;" (click)="enableAllIcdCodes()">
        <i class="fa fa-check" style="margin-top:6px;color:#fff;"></i> Enable All Fields
      </button>
      <button *ngIf="!isEnebleAllIcdCodes && configurationList.length>0" class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;" (click)="disableAllIcdCodes()">
        <i class="fa fa-ban" style="margin-top:6px;color:#fff;"></i> Disable All Fields
      </button>
    </div>
  </div>
  <div class="content-body padding-top-20 padding-bottom-20 padding-left-5 padding-right-5">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr style="background: #dbefff;">
            <th style="padding:10px;">Disease Name</th>
            <th>Diagnosis (ICD Code)</th>
            <th>Disease Category</th>
            <th>Eye Segment</th>
            <th>Device Specific</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!configurationList || configurationList.length === 0">
            <td colspan="6" class="text-center">No Record(s)</td>
          </tr>
          <tr *ngFor="let itr of configurationList; let i = index">
            <td>
              <input [(ngModel)]="itr.description" type="text" class="form-control form-control-sm"
                placeholder="Enter disease name" required #descriptionModel="ngModel" name="descriptionModel{{i}}"
                id="descriptionModel{{i}}" />
              <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="text-danger small mt-1">
                *Required</div>
            </td>
            <td>
              <input [(ngModel)]="itr.code" type="text" class="form-control form-control-sm" disabled
                name="codeModel{{i}}" id="codeModel{{i}}" />
            </td>
            <td>
              <select [(ngModel)]="itr.diseaseCategory" class="form-select form-select-sm" required
                #diseaseCategoryModel="ngModel" name="diseaseCategoryModel{{i}}" id="diseaseCategoryModel{{i}}">
                <option *ngFor="let diseaseCategory of diseaseCategoryOptions" [ngValue]="diseaseCategory.id">
                  {{ diseaseCategory.name }}
                </option>
              </select>
            </td>
            <td>
              <select [(ngModel)]="itr.eyeSegment" class="form-select form-select-sm" required
                #eyeSegmentModel="ngModel" name="eyeSegmentModel{{i}}" id="eyeSegmentModel{{i}}">
                <option *ngFor="let eyeSegment of eyeSegmentOptions" [ngValue]="eyeSegment.id">
                  {{ eyeSegment.name }}
                </option>
              </select>
            </td>
            <td>
              <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
                <option *ngFor="let device of devices" [ngValue]="device.id">
                  {{ device.name }}
                </option>
              </select>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <table class="table table table-borderless">
        <tr style="background: #f0f3f6;">
          <th style="padding:10px;">Disease Name</th>
          <th style="width:30%">Diagnosis(ICD Code)</th>
          <th>Disease Category</th>
          <th>Eye Segment</th>
          <th>Device Specific</th>
          <th class="text-center">Status</th>
        </tr>
        <tr *ngIf="configurationList.length==0 || configurationList==null">
          <td colspan="6" class="text-center">No Record(s)</td>
        </tr>
        <tr *ngFor="let itr of configurationList;let i=index">
          <td>
            <input [(ngModel)]="itr.description" type="text" class="form-control" required
              placeholder="Enter disease name" #descriptionModel="ngModel" name="descriptionModel" id="descriptionModel"
              style="padding-left:10px;">
            <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="danger-text">*Required</div>
          </td>
          <td>
            <input [(ngModel)]="itr.code" type="text" class="form-control" required placeholder=""
              name="descriptionModel" id="descriptionModel" style="padding-left:10px;" disabled>
          </td>
          <td>
            <select [(ngModel)]="itr.diseaseCategory" class="form-select form-select-sm" required #diseaseCategoryModel="ngModel"
              name="diseaseCategoryModel" id="diseaseCategoryModel">
              <option *ngFor="let diseaseCategory of diseaseCategoryOptions" [ngValue]="diseaseCategory.id">
                {{diseaseCategory.name}}</option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="itr.eyeSegment" class="form-select form-select-sm" required #eyeSegmentModel="ngModel"
              name="eyeSegmentModel" id="eyeSegmentModel">
              <option *ngFor="let eyeSegment of eyeSegmentOptions" [ngValue]="eyeSegment.id">{{eyeSegment.name}}
              </option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
              <option *ngFor="let device of devices" [ngValue]="device.id">{{device.name}}</option>
            </select>
          </td>
          <td class="text-center" style="padding-top: 10px !important;">
            <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
          </td>
        </tr>
      </table> -->
    </div>
    <div class="text-center mTop15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="onSubmit('DIAGNOSIS')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Diagnosis</button>
    </div>
  </div>
</div>
<!-- end : ICD Codes-->
<!-- start : Findings Codes-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='FINDINGS'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Findings Configuration
    <div class="pull-right">
      <!-- <button class="btn btn-sm btn-primary" style="margin-top: -4px;" (click)="addNewRow('FINDINGS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field
      </button>
      <button class="btn btn-sm btn-warning" style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;" (click)="getDefaultConfigurations('FINDINGS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add Default Fields
      </button>
      <button class="btn btn-sm btn-danger" style="margin-top: -4px;margin-left: 5px;" (click)="deleteConfigurations('FINDINGS')">
        <i class="fa fa-trash" style="margin-top:6px;color:#fff;"></i> Remove All Fields
      </button> -->
      <button *ngIf="isEnableFindingAllIcdCodes && findingsList.length>0" class="btn btn-sm btn-primary"
        style="margin-top: -4px;" (click)="enableAllFindingsIcdCodes()">
        <i class="fa fa-check" style="margin-top:6px;color:#fff;"></i> Enable All Fields
      </button>
      <button *ngIf="!isEnableFindingAllIcdCodes && findingsList.length>0" class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="disableAllFindingsIcdCodes()">
        <i class="fa fa-ban" style="margin-top:6px;color:#fff;"></i> Disable All Fields
      </button>
    </div>

  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr style="background: #dbefff;">
            <th style="padding:10px;">Finding Name</th>
            <th>Code</th>
            <th>Device Specific</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!findingsList || findingsList.length === 0">
            <td colspan="4" class="text-center">No Record(s)</td>
          </tr>
          <tr *ngFor="let itr of findingsList; let i = index">
            <td>
              <input [(ngModel)]="itr.description" type="text" class="form-control form-control-sm"
                placeholder="Enter finding name" required #descriptionModel="ngModel" name="descriptionModel{{i}}"
                id="descriptionModel{{i}}" />
              <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="text-danger small mt-1">
                *Required
              </div>
            </td>
            <td>
              <input [(ngModel)]="itr.code" type="text" class="form-control form-control-sm" disabled
                name="codeModel{{i}}" id="codeModel{{i}}" />
            </td>
            <td>
              <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
                <option *ngFor="let device of devices" [ngValue]="device.id">{{ device.name }}</option>
              </select>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center mTop15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="onSubmit('FINDINGS')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Findings</button>
    </div>
  </div>
</div>
<!-- end : Findings Codes-->
<!-- start : progression section-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='PROGRESSION'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Progression Section Configuration
    <div class="pull-right">
      <!-- <button class="btn btn-sm btn-primary" style="margin-top: -4px;" (click)="addNewRow('PROGRESSION')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field
      </button>
      <button class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="getDefaultConfigurations('PROGRESSION')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add Default Fields
      </button>
      <button class="btn btn-sm btn-danger" style="margin-top: -4px;margin-left: 5px;"
        (click)="deleteConfigurations('PROGRESSION')">
        <i class="fa fa-trash" style="margin-top:6px;color:#fff;"></i> Remove All Fields
      </button> -->
      <button *ngIf="isEnableProgressionAllIcdCodes && progressionSectionList.length>0" class="btn btn-sm btn-primary"
        style="margin-top: -4px;" (click)="enableAllProgressionIcdCodes()">
        <i class="fa fa-check" style="margin-top:6px;color:#fff;"></i> Enable All Fields
      </button>
      <button *ngIf="!isEnableProgressionAllIcdCodes && progressionSectionList.length>0" class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="disableAllProgressionIcdCodes()">
        <i class="fa fa-ban" style="margin-top:6px;color:#fff;"></i> Disable All Fields
      </button>
    </div>
  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr style="background: #dbefff;">
            <th style="padding:10px;">Progression Name</th>
            <th>Code</th>
            <th>Device Specific</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!progressionSectionList || progressionSectionList.length === 0">
            <td colspan="4" class="text-center">No Record(s)</td>
          </tr>
          <tr *ngFor="let itr of progressionSectionList; let i = index">
            <td>
              <input [(ngModel)]="itr.description" type="text" class="form-control form-control-sm"
                placeholder="Enter progression name" required #descriptionModel="ngModel" name="descriptionModel{{i}}"
                id="descriptionModel{{i}}" />
              <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="text-danger small mt-1">
                *Required
              </div>
            </td>
            <td>
              <input [(ngModel)]="itr.code" type="text" class="form-control form-control-sm" disabled
                name="codeModel{{i}}" id="codeModel{{i}}" />
            </td>
            <td>
              <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
                <option *ngFor="let device of devices" [ngValue]="device.id">{{ device.name }}</option>
              </select>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center mTop15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="onSubmit('PROGRESSION')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Progression</button>
    </div>
  </div>
</div>
<!-- end : progression section-->
<!-- start : recommendation section-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='RECOMMENDATIONS'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Recommendation Configuration
    <div class="pull-right">
      <!-- <button class="btn btn-sm btn-primary" style="margin-top: -4px;" (click)="addNewRow('RECOMMENDATIONS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field
      </button>
      <button class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="getDefaultConfigurations('RECOMMENDATIONS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add Default Fields
      </button>
      <button class="btn btn-sm btn-danger" style="margin-top: -4px;margin-left: 5px;"
        (click)="deleteConfigurations('RECOMMENDATIONS')">
        <i class="fa fa-trash" style="margin-top:6px;color:#fff;"></i> Remove All Fields
      </button> -->
      <button *ngIf="isEnableRecommendationAllIcdCodes && recommendationList.length>0" class="btn btn-sm btn-primary"
        style="margin-top: -4px;" (click)="enableAllRecommendationIcdCodes()">
        <i class="fa fa-check" style="margin-top:6px;color:#fff;"></i> Enable All Fields
      </button>
      <button *ngIf="!isEnableRecommendationAllIcdCodes && recommendationList.length>0" class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="disableAllRecommendationIcdCodes()">
        <i class="fa fa-ban" style="margin-top:6px;color:#fff;"></i> Disable All Fields
      </button>
    </div>

  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr style="background: #dbefff;">
            <th style="padding:10px;">Recommendation Name</th>
            <th>Code</th>
            <th>Device Specific</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!recommendationList || recommendationList.length === 0">
            <td colspan="4" class="text-center">No Record(s)</td>
          </tr>
          <tr *ngFor="let itr of recommendationList; let i = index">
            <td>
              <input [(ngModel)]="itr.description" type="text" class="form-control form-control-sm"
                placeholder="Enter recommendation name" required #descriptionModel="ngModel"
                name="descriptionModel{{i}}" id="descriptionModel{{i}}" />
              <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="text-danger small mt-1">
                *Required
              </div>
            </td>
            <td>
              <input [(ngModel)]="itr.code" type="text" class="form-control form-control-sm" disabled
                name="codeModel{{i}}" id="codeModel{{i}}" />
            </td>
            <td>
              <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
                <option *ngFor="let device of devices" [ngValue]="device.id">{{ device.name }}</option>
              </select>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center mTop15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="onSubmit('RECOMMENDATIONS')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Recommendation</button>
    </div>
  </div>
</div>
<!-- end : recommendation-->
<!-- start : Operator Remarks section-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='OPERATOR_REMARKS'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Operator Remarks Configuration
    <div class="pull-right">
      <!-- <button class="btn btn-sm btn-primary" style="margin-top: -4px;" (click)="addNewRow('OPERATOR_REMARKS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field
      </button>
      <button class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="getDefaultConfigurations('OPERATOR_REMARKS')">
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add Default Fields
      </button>
      <button class="btn btn-sm btn-danger" style="margin-top: -4px;margin-left: 5px;"
        (click)="deleteConfigurations('OPERATOR_REMARKS')">
        <i class="fa fa-trash" style="margin-top:6px;color:#fff;"></i> Remove All Fields
      </button> -->
      <button *ngIf="isEnableRemarksAllIcdCodes && operatorRemarksList.length>0" class="btn btn-sm btn-primary"
        style="margin-top: -4px;" (click)="enableAllRemarksIcdCodes()">
        <i class="fa fa-check" style="margin-top:6px;color:#fff;"></i> Enable All Fields
      </button>
      <button *ngIf="!isEnableRemarksAllIcdCodes && operatorRemarksList.length>0" class="btn btn-sm btn-warning"
        style="margin-top: -4px;margin-left: 5px;background-color: rgb(255,131,0) ;"
        (click)="disableAllRemarksIcdCodes()">
        <i class="fa fa-ban" style="margin-top:6px;color:#fff;"></i> Disable All Fields
      </button>
    </div>

  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead>
          <tr style="background: #dbefff;">
            <th style="padding:10px;">Remarks Name</th>
            <th>Code</th>
            <th>Device Specific</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!operatorRemarksList || operatorRemarksList.length === 0">
            <td colspan="4" class="text-center">No Record(s)</td>
          </tr>
          <tr *ngFor="let itr of operatorRemarksList; let i = index">
            <td>
              <input [(ngModel)]="itr.description" type="text" class="form-control form-control-sm"
                placeholder="Enter remark name" required #descriptionModel="ngModel" name="descriptionModel{{i}}"
                id="descriptionModel{{i}}" />
              <div [hidden]="descriptionModel.valid || descriptionModel.pristine" class="text-danger small mt-1">
                *Required
              </div>
            </td>
            <td>
              <input [(ngModel)]="itr.code" type="text" class="form-control form-control-sm" disabled
                name="codeModel{{i}}" id="codeModel{{i}}" />
            </td>
            <td>
              <select [(ngModel)]="itr.deviceId" class="form-select form-select-sm">
                <option *ngFor="let device of devices" [ngValue]="device.id">{{ device.name }}</option>
              </select>
            </td>
            <td class="text-center" style="vertical-align: middle;">
              <p-inputSwitch [(ngModel)]="itr.status"></p-inputSwitch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center mTop15">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5"
        (click)="onSubmit('OPERATOR_REMARKS')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Remarks</button>
    </div>
  </div>
</div>
<!-- end : Operator Remarks-->
<!-- start : MRN configuration section-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='MRN_CONFIGURATION'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    <div class="pull-left" style="float: left;">MRN Configuration</div>
    <div class="text-center"><span
        style="font-size: 16px;color: green;font-weight: bold;background-color: lightyellow;border-radius: 5px;padding: 5px;">MRN
        : {{previewMRN}}</span></div>
  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <div class="col-lg-6">
        <div class="panel panel-primary " style="padding: 0px;">
          <div class="panel panel-heading text-center" style="border-radius: 0px;margin-bottom: 0px;height: 30px;">
            Account</div>
          <div class="panel-body">
            <div class="col-xs-12 table-responsive">
              <table class="table table-bordered align-middle">
                <tbody>
                  <tr style="background:#dbefff;">
                    <td class="fw-bold">Account Name</td>
                    <td>{{ selectedAccount?.accountName }}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Account Code</td>
                    <td>{{ selectedAccount?.accountCode }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- <div class="col-xs-6 float-left" style="padding-left: 0px;">Account Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
              <div class="col-xs-6" style="padding-left: 0px;">{{selectedAccount.name}}</div>
            </div>
            <div class="col-xs-12">
              <div class="col-xs-6 float-left" style="padding-left: 0px;">Account Code &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
              <div class="col-xs-6" style="padding-left: 0px;">{{selectedAccount.accountCode}}</div>-->
            </div>
          </div>
          <div class="panel panel-footer text-center"
            style="border-radius: 0px;margin-bottom: 2px;padding-bottom: 0px;">
            <p-inputSwitch [(ngModel)]="mrnConfig.isAccountCodeActive"
              (ngModelChange)="generateMRNPreview()"></p-inputSwitch>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="panel panel-primary" style="padding: 0px;">
          <div class="panel panel-heading text-center" style="border-radius: 0px;margin-bottom: 0px;height: 30px;">
            Screening Center</div>
          <div class="panel-body">
            <div class="col-xs-12 table-responsive">
              <table class="table table-bordered align-middle">
                <tbody>
                  <tr style="background:#dbefff;">
                    <td class="fw-bold">Center Name</td>
                    <td>
                      <select [(ngModel)]="selectedScreeningCenter" class="form-select form-select-sm"
                        (ngModelChange)="generateMRNPreview()">
                        <option *ngFor="let itr of screeningCenterList; let i = index" [ngValue]="itr">
                          {{ itr.orgName }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Center Code</td>
                    <td>{{ selectedScreeningCenter?.orgCode }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- <div class="col-xs-6 float-left" style="padding-left: 0px;">Center Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
            <div class="col-xs-6" style="padding-left: 0px;">
            <select [(ngModel)]="selectedScreeningCenter" class="form-select form-select-sm" (ngModelChange)="generateMRNPreview()">
              <option *ngFor="let itr of screeningCenterList;let i=index" [ngValue]="itr">{{itr.orgName}}</option>
            </select></div>
          </div>
          <div class="col-xs-12">
            <div class="col-xs-6 float-left" style="padding-left: 0px;">Center Code &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
            <div class="col-xs-6" style="padding-left: 0px;">{{selectedScreeningCenter.orgCode}}</div> -->
            </div>
          </div>
          <div class="panel panel-footer text-center"
            style="border-radius: 0px;margin-bottom: 2px;padding-bottom: 0px;">
            <p-inputSwitch [(ngModel)]="mrnConfig.isCenterCodeActive"
              (ngModelChange)="generateMRNPreview()"></p-inputSwitch>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="panel panel-primary" style="padding: 0px;">
          <div class="panel panel-heading text-center" style="border-radius: 0px;margin-bottom: 0px;height: 30px;">Date
          </div>
          <div class="panel-body">
            <div class="col-xs-12 table-responsive">
              <table class="table table-bordered align-middle">
                <tbody>
                  <tr style="background:#dbefff;">
                    <td class="fw-bold">Configure Date Format</td>
                    <td>
                      <select [(ngModel)]="mrnConfig.dateFormat" class="form-select form-select-sm"
                        (ngModelChange)="generateMRNPreview()">
                        <option value="ddMMyyyy">ddMMyyyy</option>
                        <option value="MMddyyyy">MMddyyyy</option>
                        <option value="yyyyMMdd">yyyyMMdd</option>
                        <option value="ddMMyyyyhhmmssS">ddMMyyyyhhmmssS</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <div class="col-xs-6 float-left" style="padding-left: 0px;">Configure Date Format &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
            <div class="col-xs-6" style="padding-left: 0px;">
              <select [(ngModel)]="mrnConfig.dateFormat" class="form-select form-select-sm" (ngModelChange)="generateMRNPreview()">
                <option value="ddMMyyyy">ddMMyyyy</option>
                <option value="MMddyyyy">MMddyyyy</option>
                <option value="yyyyMMdd">yyyyMMdd</option>
              </select></div> -->
            </div>
          </div>
          <div class="panel panel-footer text-center"
            style="border-radius: 0px;margin-bottom: 2px;padding-bottom: 0px;">
            <p-inputSwitch [(ngModel)]="mrnConfig.isDateFormatActive"
              (ngModelChange)="generateMRNPreview()"></p-inputSwitch>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="panel panel-primary" style="padding: 0px;">
          <div class="panel panel-heading text-center" style="border-radius: 0px;margin-bottom: 0px;height: 30px;">
            Serial Number</div>
          <div class="panel-body">
            <div class="col-xs-12 table-responsive">
              <table class="table table-bordered align-middle">
                <tbody>
                  <tr style="background:#dbefff;">
                    <td class="fw-bold">Number of Digits</td>
                    <td>
                      <select [(ngModel)]="mrnConfig.noOfDigits" class="form-select form-select-sm"
                        (ngModelChange)="generateMRNPreview()">
                        <option *ngFor="let itr of [1,2,3,4,5,6,7,8,9,10]" [ngValue]="itr">{{ itr }}</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <div class="col-xs-6 float-left" style="padding-left: 0px;">Number of Digits &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</div>
            <div class="col-xs-6" style="padding-left: 0px;">
              <select [(ngModel)]="mrnConfig.noOfDigits" class="form-select form-select-sm" (ngModelChange)="generateMRNPreview()">
                <option *ngFor="let itr of [1,2,3,4,5,6,7,8,9,10]" [ngValue]="itr">{{itr}}</option>
              </select></div> -->
            </div>
          </div>
          <div class="panel panel-footer text-center"
            style="border-radius: 0px;margin-bottom: 2px;padding-bottom: 0px;">
            <p-inputSwitch [(ngModel)]="mrnConfig.isSerialNumberActive"
              (ngModelChange)="generateMRNPreview()"></p-inputSwitch>
          </div>
        </div>
      </div>
      <div class="text-center mTop15">
        <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5"
          (click)="onSubmit('MRN_CONFIGURATION')">
          <i class="fa fa-fw fa-lg fa-check-circle"></i> Save MRN Configuration</button>
        <button style="margin-right: 5px;" class="btn btn-sm btn-danger marginLR5"
          (click)="onSubmit('REMOVE_MRN_CONFIGURATION')">
          <i class="fa fa-fw fa-lg fa-times-circle"></i> Remove Configuration</button>
      </div>
    </div>
  </div>
</div>
<!-- end : MRN Configuration section-->

<!-- start : Account configuration section-->
<div *ngIf="accounts!=null && accountId!=null && accountId>0 && selectedTab=='ACCOUNT_CONFIGURATION'"
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:27px;padding-right:0px;padding-top: 20px;">
  <div class="card-header">
    Account Configuration
  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="table-responsive">
      <div *ngIf="true; then tableTemplate;"></div>
      <ng-template #tableTemplate>
        <p-table [value]="accountConfigurationMap"
          [paginator]="accountConfigurationMap!=null && accountConfigurationMap.length>10" [rows]="10"
          class="table table-striped">
          <ng-template pTemplate="header">
            <tr style="height: 65px;">
              <th class="col-lg-6" style="width:100px;text-align: center;">#</th>
              <th style="width:450px">Configuration Keys</th>
              <th>Description</th>
              <th>Configuration Values </th>
            </tr>
            <tr *ngIf="accountConfigurationMap==null || accountConfigurationMap.length==0"
              style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
              <td colspan="4">
                <div style="padding: 5px;text-align: center;"> No record found </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-map let-i="rowIndex">
            <tr class="table-striped" style="cursor: pointer;">
              <td style="text-align: center;">
                {{i+1}}
              </td>
              <td>{{map.keylabel}}</td>
              <td>{{map.keyDescription}}</td>
              <td style="background-color: white;"><input type="text" placeholder="Enter value" [(ngModel)]="map.value"
                  class="form-control"> </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
    </div>
    <div class="text-center mTop15" *ngIf="accountConfigurationMap!=null && accountConfigurationMap.length>0">
      <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5"
        (click)="onSubmit('ACCOUNT_CONFIGURATION')">
        <i class="fa fa-fw fa-lg fa-check-circle"></i> Save</button>
    </div>
  </div>
</div>
<!-- end : Account Configuration section-->